export default "__VITE_ASSET__SJAXZ5Oo__"